
// toggle menu in mobile screen//

$(".hamburger_collapse").click(function() {
    $(this).toggleClass("on");
    $(".nav-ul").slideToggle();
    return false;
});

//on click, add class active and remove class active from menu//
$(document).ready(function() {
    $(".nav-link").click(function () {
        $(".nav-link").removeClass("active");
        $(this).addClass("active");
    });
});




